import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function resolveAssetUrl(value, fallback = '/vegas-lobby-logo.webp') {
  if (!value || typeof value !== 'string') return fallback;
  const url = value.trim();
  if (!url) return fallback;
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  if (url.startsWith('//')) return `${window.location.protocol}${url}`;
  if (url.startsWith('/')) return url;
  return `/${url.replace(/^\/+/, '')}`;
}

const PROVIDER_LOGOS = {
  firekirin: '/provider-logos/firekirin.webp',
  fire_kirin: '/provider-logos/firekirin.webp',
  game_vault: '/provider-logos/gamevault.webp',
  gamevault: '/provider-logos/gamevault.webp',
  gamer_room: '/provider-logos/gameroom.webp',
  gameroom: '/provider-logos/gameroom.webp',
  juwa: '/provider-logos/juwa.webp',
  juwa2: '/provider-logos/juwa2.webp',
  juwa_2_0: '/provider-logos/juwa2.webp',
  panda_master: '/provider-logos/pandamaster.webp',
  pandamaster: '/provider-logos/pandamaster.webp',
  ultra_panda: '/provider-logos/ultrapanda.webp',
  ultrapanda: '/provider-logos/ultrapanda.webp',
};

const normalizeProviderKey = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/&/g, 'and')
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_+|_+$/g, '');

export function localProviderLogo(game) {
  const keys = [
    game?.provider_code,
    game?.provider,
    game?.code,
    game?.id,
    game?.name,
  ].map(normalizeProviderKey);
  return keys.map((key) => PROVIDER_LOGOS[key]).find(Boolean) || '';
}

export function optimizedUploadUrl(value, width = 720, quality = 72) {
  if (!value || typeof value !== 'string') return value;
  const raw = value.trim();
  if (!raw || /^(data:|blob:)/i.test(raw)) return raw;
  const widthValue = Math.max(96, Math.min(2000, Number(width) || 720));
  const qualityValue = Math.max(45, Math.min(85, Number(quality) || 72));
  const appendParams = (url) => `${url}${url.includes('?') ? '&' : '?'}w=${widthValue}&q=${qualityValue}`;
  if (raw.startsWith('/api/uploads/')) return appendParams(raw);
  if (raw.startsWith('/uploads/')) return appendParams(raw.replace(/^\/uploads\//, '/api/uploads/'));
  try {
    const url = new URL(raw);
    if (url.pathname.startsWith('/uploads/')) url.pathname = url.pathname.replace(/^\/uploads\//, '/api/uploads/');
    if (url.pathname.startsWith('/api/uploads/')) {
      url.searchParams.set('w', String(widthValue));
      url.searchParams.set('q', String(qualityValue));
      return url.toString();
    }
  } catch {
    return raw;
  }
  return raw;
}

export function bannerSlideDurationMs(banner, fallbackMs = 7000) {
  const raw = banner?.slide_duration_ms
    ?? banner?.display_duration_ms
    ?? banner?.duration_ms
    ?? banner?.slide_seconds;
  let ms = Number(raw);
  if (!Number.isFinite(ms) || ms <= 0) ms = Number(fallbackMs) || 7000;
  if (ms > 0 && ms < 1000) ms *= 1000;
  return Math.max(2000, Math.min(30000, Math.round(ms)));
}

export function gameImageUrl(game, fallback = '/vegas-lobby-logo.webp') {
  return resolveAssetUrl(localProviderLogo(game) || game?.logo_image_url || game?.logo_url || game?.image, fallback);
}

export function handleImageFallback(event, fallback = '/vegas-lobby-logo.webp') {
  const img = event.currentTarget;
  if (img.dataset.fallbackApplied === '1') return;
  img.dataset.fallbackApplied = '1';
  img.src = fallback;
}
